import React from "react"
import style from "./map.module.scss"

function Map(props) {
  return (
    <div className="container">
      <div className={style.map}>
          <h2 className={style.mapTitle}>{props.title}</h2>
          <iframe
          src={props.location}
          width="100%" height="600" frameBorder="0" style={{ border: 0 }} allowFullScreen="" aria-hidden="false"
          loading="lazy"
          title="google map"
        />
      </div>
    </div>
  )
}

export default Map